import clsx from 'clsx';
import ReactMarkdown, { ReactMarkdownOptions } from 'react-markdown';

export interface IBaseMarkdownProps {
    markdown: string;
    className?: string;
    options?: ReactMarkdownOptions;
}

const BaseMarkdown: React.FC<IBaseMarkdownProps> = ({ markdown, className, options }) => {
    return (
        <ReactMarkdown
            {...options}
            className={clsx('markdown', className)}
            components={{
                a: ({ href, children }) => {
                    return (
                        <a
                            href={href}
                            target="_blank"
                            className={clsx({
                                'markdown-link': href.search(/mailto/g) !== -1,
                            })}
                            rel="noreferrer"
                        >
                            {children}
                        </a>
                    );
                },
            }}
        >
            {markdown}
        </ReactMarkdown>
    );
};

export default BaseMarkdown;
